import type * as React from 'react';

import { Button } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ErrorState } from '@/components/shell';
import { Routes } from '@/constants/routes';

export const NotFoundPage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <ErrorState
      data-testid="not-found-page"
      icon={<SearchOffIcon />}
      code={t('notFound.code')}
      title={t('notFound.title')}
      description={t('notFound.description')}
      actions={
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(Routes.HOME)}
          sx={{ minHeight: 44 }}
        >
          {t('backToOverview')}
        </Button>
      }
    />
  );
};
